import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BalanceService } from '../../../core/services/api/balance.service';
import { Transaction } from '../../../models/transaction';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-balance-history',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, TagModule, TranslocoPipe],
  templateUrl: './balance-history.component.html',
  styleUrls: ['./balance-history.component.scss'],
})
export class BalanceHistoryComponent implements OnInit {
  balanceService = inject(BalanceService);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  cdr = inject(ChangeDetectorRef);

  transactions: Transaction[] = [];
  loading: boolean;

  ngOnInit() {
    this.maximizeDialog();
    this.loadBalanceHistory();
  }

  maximizeDialog() {
    const maximizeButton = document.querySelector('.p-dialog .p-dialog-maximize-button');
    (maximizeButton as HTMLElement)?.click();
  }

  async loadBalanceHistory() {
    try {
      this.loading = true;
      const response: any = await this.balanceService.getBalanceHistory();
      this.transactions =
        response.transactions.map((transaction: any) => ({
          ...transaction.data,
        })) || [];

      this.transactions.sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );
    } catch (error) {
      console.error('Error loading balance history:', error);
      this.transactions = [];
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  getSeverity(balanceChange: string): any {
    const change = parseFloat(balanceChange);
    if (change > 0) return 'success';
    if (change < 0) return 'danger';
    return 'info';
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleString();
  }

  formatBalance(balance: string): string {
    return parseFloat(balance).toFixed(6) + ' $';
  }

  formatTokenCost(cost: string): string {
    return parseFloat(cost).toFixed(6);
  }

  close() {
    this.ref.close();
  }
}
